import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";
import moment from 'moment';

export default {
    GetDivisionSummaryDetailReportData,
    getEstatesByGroupID
};

async function GetDivisionSummaryDetailReportData(estateID, searchDate) {
    var newModel = {
        estateID: parseInt(estateID),
        searchDate: searchDate,
    }
    const response = await CommonPost('/api/DivisionSummaryDetailReport/GetDivisionSummaryDetailReportData', null, newModel);
    return response;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return estateArray;
}

